import React from "react";
import styled from "@emotion/styled";

const IndustryChips = ({ industries = [], maxDisplay = null }) => {
  if (!industries || industries.length === 0) return null;

  const industriesToShow = Array.isArray(industries) ? industries : [];
  const displayItems = maxDisplay ? industriesToShow.slice(0, maxDisplay) : industriesToShow;
  const remaining = maxDisplay && industriesToShow.length > maxDisplay
    ? industriesToShow.length - maxDisplay
    : 0;

  return (
    <ChipsContainer>
      {displayItems.map((industry, index) => (
        <Chip key={index}>
          <ChipText>{industry}</ChipText>
        </Chip>
      ))}
      {remaining > 0 && (
        <Chip>
          <ChipText>+{remaining}</ChipText>
        </Chip>
      )}
    </ChipsContainer>
  );
};

const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

const Chip = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  background: #F1F5F9;
  border-radius: 6px;
  white-space: nowrap;
`;

const ChipText = styled.span`
  color: #64748B;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 140%;
`;

export default IndustryChips;
